import { createSelector } from 'reselect';

export const adminJobsSelector = state => state.administration.applicationSettings.adminJobs;

export const adminJobsForDroplistSelector = createSelector(
  adminJobsSelector,
  adminJobs => adminJobs.map(job => ({ label: job, value: job }))
);

export const adminJobInProgressNameSelector = state => state.administration.applicationSettings.adminJobInProgressName;

export const adminJobsFetchingSelector = state => state.administration.applicationSettings.adminJobsFetching;

export const deactivateUsersJobInProgressSelector = state =>
  state.administration.applicationSettings.deactivateUsersJobInProgress;

export const clearBsmBalancesInProgressSelector = state =>
  state.administration.applicationSettings.clearBsmBalancesInProgress;

export const companyCodesSelector = state => state.shared.companyCodes;

export const companyCodesForDroplistSelector = createSelector(
  companyCodesSelector,
  companyCodes => companyCodes.map(companyCode => ({ label: companyCode.cc, value: companyCode.cc }))
);

export const selectedCompanyCodesSelector = state => state.administration.applicationSettings.selectedCompanyCodes;

export const userClientsSelector = state => state.user.clients;

export const lastClientIdSelector = state => state.user.user.lastClientId;

export const lastClientSelector = createSelector(
  userClientsSelector,
  lastClientIdSelector,
  (clients, lastClientId) => clients.find(client => client.clientId === lastClientId).name
);

export const periodsForDroplistSelector = createSelector(
  ({ shared }) => shared.periods,
  periods => periods.map(({ name, taxYear }) => ({
    value: name,
    label: name,
    taxYear,
  }))
);

export const selectedPeriodsSelector = state => state.administration.applicationSettings.selectedPeriods;
